export enum RETURN_METHODS {
  SELF = 'SELF_RETURN',
  COURIER = 'PICKUP_RETURN',
}
